import { updateGateState, updateGatewayState, updateWarehouseState } from 'containers/Warehouses/warehousesSlice'
import { addMessage, addChatNotification, updateMessage } from 'containers/Chats/chatSlice'
import useNotificationRequest from 'containers/Chats/hooks/useNotificationRequest'
import { addNotification } from 'containers/Notifications/notificationsSlice'
import { updateObject } from 'containers/Playground/playgroundSlice'
import useWssConnection from './useWssConnection'
import SocketContext from './SocketContext'
import { useDispatch } from 'react-redux'
import { useEffect, useRef } from 'react'
import logo from 'assets/logo.svg'

const SocketProvider = ({ children }) => {
  const { messageData, sendMessage } = useWssConnection()

  const currentSend = useRef(sendMessage)
  currentSend.current = sendMessage

  const dispatch = useDispatch()
  const { read } = useNotificationRequest()

  useEffect(() => {
    switch (messageData.event) {
      case 'map_object_state': {
        const { object_id, data } = messageData.payload || {}
        dispatch(updateObject({ type: data?.type, id: object_id, values: data?.map || {}, status: data?.status }))
        break
      }

      case 'newMessage':
        dispatch(addMessage(messageData.payload))
        if (messageData.payload.id) {
          currentSend.current({
            command: 'deliveredMessage',
            payload: {
              chatId: messageData.payload.chat_id,
              messageId: messageData.payload.id
            }
          })
        }
        if (!window.location.pathname.includes('chat')) {
          if ('Notification' in window && Notification?.permission === 'granted') {
            new Notification('Masz nową wiadomość', {
              body: messageData.payload.message,
              icon: logo
            })
          }
        }
        break

      case 'sentMessage': {
        if (messageData.payload.id && messageData.payload.chat_id) {
          dispatch(updateMessage({
            messageId: messageData.payload.id,
            chatId: messageData.payload.chat_id,
            values: { sentDate: new Date().toJSON() }
          }))
        }
        break
      }

      case 'deliveredMessage':
      case 'readMessage': {
        if (messageData.payload.messageId && messageData.payload.chatId) {
          dispatch(updateMessage({
            messageId: messageData.payload.messageId,
            chatId: messageData.payload.chatId,
            values: messageData.event === 'deliveredMessage'
              ? { deliveredDate: new Date().toJSON() }
              : { readDate: new Date().toJSON() }
          }))
        }
        break
      }

      case 'userNotification': {
        const notification = messageData.payload?.notification
        if (notification) {
          dispatch(addChatNotification(notification))
          const isMessagesPage = window.location.pathname.match(/^\/chat(\/?)$/)
          const isChatPage = notification.chatId ? window.location.pathname.includes(`/chat/${notification.chatId}`) : false
          if (isChatPage) read(notification.id)
          if (!isMessagesPage && !isChatPage) {
            dispatch(addNotification({
              type: notification.type,
              message: 'youHaveANewMessage',
              chatMessage: true,
              translate: true
            }))
          }
        }
        break
      }

      case 'gate_opened':
      case 'gate_opening':
      case 'gate_closed':
      case 'gate_closing': {
        if (messageData.payload?.object_id && messageData.payload?.place_id) {
          dispatch(updateGateState({ id: messageData.payload.object_id, placeId: messageData.payload?.place_id, state: messageData.event }))
        }
        break
      }

      case 'gateway_unlocked':
      case 'gateway_opened':
      case 'gateway_closed': {
        if (messageData.payload?.object_id && messageData.payload?.place_id) {
          dispatch(updateGatewayState({ id: messageData.payload.object_id, placeId: messageData.payload?.place_id, state: messageData.event }))
        }
        break
      }

      case 'depot_lock_opened':
      case 'depot_lock_closed': {
        if (messageData.payload?.object_id) {
          dispatch(updateWarehouseState({
            id: messageData.payload.object_id,
            doorState: {
              lock: messageData.event === 'depot_lock_opened' ? 'unlocked' : 'locked'
            }
          }))
        }
        break
      }

      case 'depot_door_opened':
      case 'depot_door_closed': {
        if (messageData.payload?.object_id) {
          const doorState = messageData.event === 'depot_door_opened'
            ? {
              door: 'opened',
              lock: 'locked'
            } : {
              door: 'closed'
            }
          dispatch(updateWarehouseState({
            id: messageData.payload.object_id,
            doorState
          }))
        }
        break
      }

      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, messageData])

  return (
    <SocketContext.Provider value={{
      messageData,
      sendMessage,
    }}>
      {children}
    </SocketContext.Provider>
  )
}

export default SocketProvider